import { useState } from "react";
import Navbar from "../components/Navbar";

// ─────────────────────────────────────────────────────────────────────────────
// LANG — toate textele vizibile. Editează aici pentru orice modificare de text.
// ─────────────────────────────────────────────────────────────────────────────
const LANG = {
  ro: {
    title: "Prețuri",
    subtitle: "Evaluare editorială profesională bazată pe standardul FEUR",
    toggle: { perReport: "Per raport", subscriptions: "Abonamente" },
    popular: "Cel mai popular",
    recommended: "Recomandat instituții",
    perReport: "per raport",
    perMonth: "/ lună",
    perYear: "/ an",
    vatNote: "Prețuri fără TVA (21%)",
    saveYearly: (n) => `Economisești ${n} RON/an`,
    btnBuy: "Cumpără acum",
    btnSubscribe: "Abonează-te",
    btnFree: "Începe gratuit",

    // Freemium
    freeTitle: "Freemium",
    freeDesc: "Primele 2.000 de cuvinte — scor Hook și detecție gen",
    freeLimit: "3 analize gratuite / zi",

    // Abonamente
    subsTitle: "Abonamente",
    subsDesc: "Rapoarte la preț redus față de plata individuală",
    cycleMonthly: "Lunar",
    cycleYearly: "Anual",
    cycleBadge: "−20%",
    advantages: "De ce abonament?",
    advantagesDesc: "Acces stabil, predictibil și prioritar față de plata per raport. Ideal pentru fluxuri editoriale constante.",
    advantagesList: [
      "Prioritate la procesare față de utilizatorii per raport",
      "Acces la istoricul complet al rapoartelor",
      "Re-descărcare PDF/DOCX oricând, fără cost suplimentar",
      "Suport prioritar prin email",
      "Notificări automate la actualizări FEUR",
    ],

    // Volume options
    volLabel: "Volum manuscris",
    vol6k: "6.000 cuvinte",
    vol45k: "45.000 cuvinte",
    vol20k: "20.000 cuvinte",
    vol80k: "80.000 cuvinte",
    vol120k: "120.000 cuvinte",
    volStandard: "Standard inclus",
    volSupplement: (n) => `+${n} RON supliment`,

    // Produse — nume și descrieri
    products: {
      basic: {
        name: "Basic Report",
        tier: "Short Story · 3.000 cuvinte",
        description: "Ideal pentru povestiri scurte și proză scurtă.",
        target: "Autori independenți · Concursuri de proză scurtă",
        includes: [
          "Universal Core complet (9 motoare)",
          "Hook Engine — forța primei pagini",
          "Pacing & Structure Engine",
          "Verdict editorial FEUR",
          "Confidence Score",
          "Export PDF",
        ],
      },
      author_pro: {
        name: "Author Pro Report",
        tier: "Standard · 6.000 cuvinte",
        description: "Evaluare completă pentru primele capitole ale romanului.",
        target: "Autori de roman · Prima triere editorială",
        includes: [
          "Universal Core complet (9 motoare)",
          "Genre Module activat automat",
          "Character & Dialogue Engine",
          "Emotional & Binge Engine",
          "Verdict editorial + recomandări",
          "Confidence Score",
          "Export PDF + DOCX",
        ],
      },
      romanian_market: {
        name: "Romanian Market Report",
        tier: "Standard + Romanian Market Layer",
        description: "Analiză completă cu strat de piață românească.",
        target: "Autori români · Edituri naționale · Concursuri literare",
        includes: [
          "Tot ce include Author Pro",
          "Romanian Market Layer complet",
          "Specificitate locală: mentalitate, spațiu, conflict românesc",
          "Canale de distribuție recomandate",
          "Comparativ cu piața literară locală",
          "Logline pentru piața românească",
          "Export PDF + DOCX",
        ],
      },
      international: {
        name: "International Market Report",
        tier: "Standard + Global Market Engine",
        description: "Evaluare cu potențial de export internațional.",
        target: "Autori cu ambiții internaționale · Agenții literare",
        includes: [
          "Tot ce include Author Pro",
          "Global Market Engine",
          "Compatibilitate cu piețe: UK, US, Germania, Franța",
          "Tendințe internaționale de gen",
          "Recomandări de adaptare pentru export",
          "Logline internațional",
          "Export PDF + DOCX",
        ],
      },
      premium_comparative: {
        name: "Premium Comparative",
        tier: "Extended · 20.000 cuvinte",
        description: "Analiză aprofundată pe primele 3–4 capitole.",
        target: "Edituri · Agenții literare · Concursuri naționale",
        includes: [
          "Universal Core extins cu justificări detaliate",
          "Genre Module complet cu exemple",
          "Romanian Market Layer",
          "Global Market Engine",
          "Analiză comparativă cu titluri similare",
          "Plan de revizuire editorial",
          "Confidence Score detaliat",
          "Export PDF + DOCX",
        ],
      },
      full_manuscript: {
        name: "Full Manuscript Report",
        tier: "Roman complet · 80.000 / 120.000 cuvinte",
        description: "Analiză FEUR pe romanul integral, în două etape.",
        target: "Edituri mari · Concursuri internaționale · Agenții literare",
        includes: [
          "Rezumare structurată pe capitole (Etapa 1)",
          "Analiză FEUR completă pe rezumat (Etapa 2)",
          "Universal Core + Genre Module + Market Engines",
          "Evaluare arc narativ pe întreaga carte",
          "Verdict editorial final cu plan de revizuire",
          "Confidence Score detaliat",
          "Export PDF + DOCX",
        ],
      },
      ai_human: {
        name: "AI + Human Editorial",
        tier: "Roman complet · Review uman inclus",
        description: "Analiză AI completă pe roman integral + revizie editorială umană.",
        target: "Edituri mari · Manuscrise pentru agenții internaționale",
        includes: [
          "Full Manuscript Report complet (80.000 cuvinte standard)",
          "Revizie și validare de editor uman",
          "Feedback personalizat pe vocea autorului",
          "Sesiune de consultanță 30 min (opțional)",
          "Livrare în 5 zile lucrătoare",
          "Raport final semnat de editor",
          "Export PDF + DOCX premium",
        ],
      },
    },

    // Abonamente — nume și descrieri
    subscriptions: {
      starter: {
        name: "Starter",
        content: "10 rapoarte Author Pro / lună",
        description: "Perfect pentru autori activi care scriu constant.",
        features: [
          "10 rapoarte Author Pro incluse",
          "Rapoarte suplimentare cu 20% reducere",
          "Istoric complet rapoarte",
          "Re-descărcare PDF/DOCX nelimitată",
          "Suport email prioritar",
          "Acces la actualizări FEUR",
        ],
      },
      pro: {
        name: "Pro",
        content: "30 × Premium Comparative + 10 × Full Manuscript / lună",
        description: "Ideal pentru edituri mici și agenții literare.",
        features: [
          "30 rapoarte Premium Comparative incluse",
          "10 rapoarte Full Manuscript incluse",
          "Rapoarte suplimentare cu 25% reducere",
          "Dashboard analiză volum",
          "Export date în CSV/XLSX",
          "Istoric complet + filtrare avansată",
          "Re-descărcare PDF/DOCX nelimitată",
          "Suport prioritar + SLA 24h",
        ],
      },
      institutional: {
        name: "Instituțional",
        content: "150 Standard + 30 Premium + 10 Full Manuscript / lună",
        description: "Soluție completă pentru edituri și concursuri cu volum mare.",
        features: [
          "150 rapoarte Author Pro incluse",
          "30 rapoarte Premium Comparative incluse",
          "10 rapoarte Full Manuscript incluse",
          "API access pentru integrare proprie",
          "Dashboard admin cu statistici",
          "Export complet CSV/XLSX/JSON",
          "Manager de cont dedicat",
          "SLA 4h · Onboarding inclus",
          "Facturare în EUR",
        ],
      },
    },
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Date produse — prețuri și configurație volume
// ─────────────────────────────────────────────────────────────────────────────
const PRODUCTS = [
  {
    id: "basic",
    color: "#6B7F5E",
    price: 49,
    volumes: null,
  },
  {
    id: "author_pro",
    color: "#4A6FA5",
    price: 119,
    popular: true,
    volumes: [
      { id: "6k",  label: "vol6k",  price: 119, supplement: 0   },
      { id: "45k", label: "vol45k", price: 248, supplement: 129 },
    ],
  },
  {
    id: "romanian_market",
    color: "#8B4513",
    price: 179,
    volumes: [
      { id: "6k",  label: "vol6k",  price: 179, supplement: 0   },
      { id: "45k", label: "vol45k", price: 308, supplement: 129 },
      { id: "80k", label: "vol80k", price: 378, supplement: 199 },
      { id: "120k", label: "vol120k", price: 478, supplement: 299 },
    ],
  },
  {
    id: "international",
    color: "#2D6A8A",
    price: 199,
    volumes: [
      { id: "6k",  label: "vol6k",  price: 199, supplement: 0   },
      { id: "45k", label: "vol45k", price: 328, supplement: 129 },
      { id: "80k", label: "vol80k", price: 398, supplement: 199 },
      { id: "120k", label: "vol120k", price: 498, supplement: 299 },
    ],
  },
  {
    id: "premium_comparative",
    color: "#5C3D8F",
    price: 449,
    volumes: [
      { id: "20k", label: "vol20k", price: 449, supplement: 0   },
      { id: "45k", label: "vol45k", price: 578, supplement: 129 },
      { id: "80k", label: "vol80k", price: 648, supplement: 199 },
      { id: "120k", label: "vol120k", price: 748, supplement: 299 },
    ],
  },
  {
    id: "full_manuscript",
    color: "#3D6B5C",
    price: 649,
    volumes: [
      { id: "80k", label: "vol80k", price: 649, supplement: 0 },
      { id: "120k", label: "vol120k", price: 749, supplement: 100 },
    ],
  },
  {
    id: "ai_human",
    color: "#8B1A1A",
    price: 999,
    volumes: [
      { id: "80k", label: "volStandard", price: 999, supplement: 0 },
      { id: "120k", label: "vol120k", price: 1099, supplement: 100 },
    ],
  },
];

const SUBSCRIPTIONS = [
  {
    id: "starter",
    monthlyPrice: 249,
    yearlyPrice: 2390,
  },
  {
    id: "pro",
    monthlyPrice: 499,
    yearlyPrice: 4790,
    popular: true,
  },
  {
    id: "institutional",
    monthlyPrice: 1242,
    yearlyPrice: 11923,
    recommended: true,
  },
];

// ─────────────────────────────────────────────────────────────────────────────
// Componente
// ─────────────────────────────────────────────────────────────────────────────
function ProductCard({ product, L }) {
  const info = L.products[product.id];
  const [selectedVol, setSelectedVol] = useState(
    product.volumes ? product.volumes[0].id : null
  );

  const activeVol = product.volumes
    ? product.volumes.find((v) => v.id === selectedVol)
    : null;
  const displayPrice = activeVol ? activeVol.price : product.price;

  return (
    <div className={`product-card ${product.popular ? "popular-card" : ""}`}>
      <div className="product-header">
        <div className="product-top">
          <div className="product-color-dot" style={{ background: product.color }} />
          <div className="product-name">{info.name}</div>
          {product.popular && <span className="popular-badge">{L.popular}</span>}
        </div>
        <div className="product-tier">{info.tier}</div>
        <div className="product-desc">{info.description}</div>

        {product.volumes && (
          <div className="vol-selector">
            <div className="vol-label">{L.volLabel}</div>
            <div className="vol-options">
              {product.volumes.map((v) => (
                <button
                  key={v.id}
                  className={`vol-btn ${selectedVol === v.id ? "vol-active" : ""}`}
                  onClick={() => setSelectedVol(v.id)}
                >
                  {L[v.label]}
                  {v.supplement > 0 && (
                    <span className="vol-supplement">
                      {L.volSupplement(v.supplement)}
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="product-price-row">
          <span className="product-price">{displayPrice}</span>
          <span className="product-currency">RON</span>
          <span className="product-unit">{L.perReport}</span>
        </div>
      </div>

      <div className="product-body">
        <ul className="product-includes">
          {info.includes.map((item, i) => (
            <li key={i}>
              <span className="check-icon">✓</span>
              {item}
            </li>
          ))}
        </ul>
        <div className="product-target">{info.target}</div>
        <button className={`btn-buy ${product.popular ? "popular-btn" : ""}`}>
          {L.btnBuy}
        </button>
      </div>
    </div>
  );
}

function SubscriptionCard({ sub, billingCycle, L }) {
  const info = L.subscriptions[sub.id];
  const price = billingCycle === "yearly" ? sub.yearlyPrice : sub.monthlyPrice;
  const period = billingCycle === "yearly" ? L.perYear : L.perMonth;
  const yearlySavings = sub.monthlyPrice * 12 - sub.yearlyPrice;

  return (
    <div
      className={`sub-card ${sub.popular ? "popular-sub" : ""} ${sub.recommended ? "recommended-sub" : ""}`}
    >
      {sub.popular && <span className="sub-badge pop">{L.popular}</span>}
      {sub.recommended && <span className="sub-badge rec">{L.recommended}</span>}
      <div className="sub-name">{info.name}</div>
      <div className="sub-content">{info.content}</div>
      <div className="sub-desc">{info.description}</div>
      <div className="sub-price-row">
        <span className="sub-currency">RON</span>
        <span className="sub-price">{price.toLocaleString("ro-RO")}</span>
        <span className="sub-period">{period}</span>
      </div>
      {billingCycle === "yearly" && (
        <div className="sub-savings">
          {L.saveYearly(yearlySavings.toLocaleString("ro-RO"))}
        </div>
      )}
      <ul className="sub-features">
        {info.features.map((f, i) => (
          <li key={i}>
            <span className="check-icon">✓</span>
            {f}
          </li>
        ))}
      </ul>
      <button
        className={`btn-sub ${sub.popular ? "pop-sub" : sub.recommended ? "rec-sub" : "default"}`}
      >
        {L.btnSubscribe}
      </button>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// Pagina principală
// ─────────────────────────────────────────────────────────────────────────────
export default function Pricing() {
  const [tab, setTab] = useState("perReport");
  const [billingCycle, setBillingCycle] = useState("monthly");
  const L = LANG.ro;

  return (
    <div style={{ fontFamily: "'DM Sans', sans-serif", background: "#FAFAF7", minHeight: "100vh", color: "#1A1A18" }}>
      <Navbar />
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600&family=DM+Sans:wght@300;400;500&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }

        .pricing-wrap { max-width: 1100px; margin: 0 auto; padding: 3rem 1.5rem 5rem; }

        .pricing-hero { text-align: center; margin-bottom: 2.5rem; }
        .pricing-hero h1 { font-family: 'Cormorant Garamond', serif; font-size: clamp(2.2rem, 5vw, 3.5rem); font-weight: 300; letter-spacing: -0.02em; color: #1A1A18; margin-bottom: 0.75rem; }
        .pricing-hero p { font-size: 1rem; color: #666; font-weight: 300; max-width: 480px; margin: 0 auto 1.5rem; line-height: 1.6; }

        .tab-switcher { display: inline-flex; background: #EFEFEA; border-radius: 10px; padding: 4px; gap: 2px; }
        .tab-btn { background: none; border: none; padding: 8px 24px; border-radius: 7px; font-family: 'DM Sans', sans-serif; font-size: 14px; cursor: pointer; color: #888; transition: all 0.2s; }
        .tab-btn.active { background: #fff; color: #1A1A18; font-weight: 500; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }

        .free-tier { background: #fff; border: 1px solid #E8E8E0; border-radius: 12px; padding: 1.25rem 1.5rem; display: flex; align-items: center; justify-content: space-between; gap: 1rem; margin-bottom: 2rem; flex-wrap: wrap; }
        .free-left { display: flex; align-items: center; gap: 1rem; }
        .free-dot { width: 10px; height: 10px; border-radius: 50%; background: #8BC34A; flex-shrink: 0; }
        .free-name { font-family: 'Cormorant Garamond', serif; font-size: 1.2rem; font-weight: 500; }
        .free-desc { font-size: 13px; color: #888; }
        .free-limit { font-size: 13px; color: #aaa; font-style: italic; }
        .btn-free { background: #1A1A18; color: #fff; border: none; padding: 10px 24px; border-radius: 8px; font-family: 'DM Sans', sans-serif; font-size: 14px; cursor: pointer; transition: opacity 0.2s; white-space: nowrap; }
        .btn-free:hover { opacity: 0.8; }

        .products-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(310px, 1fr)); gap: 1.25rem; }

        .product-card { background: #fff; border: 1px solid #E8E8E0; border-radius: 14px; overflow: hidden; transition: box-shadow 0.2s, transform 0.2s; }
        .product-card:hover { box-shadow: 0 8px 32px rgba(0,0,0,0.08); transform: translateY(-2px); }
        .product-card.popular-card { border-color: #4A6FA5; border-width: 1.5px; }

        .product-header { padding: 1.25rem 1.5rem 1rem; border-bottom: 1px solid #F0F0E8; }
        .product-top { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 0.4rem; }
        .product-color-dot { width: 8px; height: 8px; border-radius: 50%; margin-top: 6px; flex-shrink: 0; }
        .popular-badge { font-size: 11px; background: #4A6FA5; color: #fff; padding: 3px 10px; border-radius: 20px; font-weight: 500; white-space: nowrap; }
        .product-name { font-family: 'Cormorant Garamond', serif; font-size: 1.3rem; font-weight: 500; color: #1A1A18; flex: 1; padding: 0 0.75rem; line-height: 1.2; }
        .product-tier { font-size: 12px; color: #aaa; padding: 0 1.5rem 0 calc(8px + 0.75rem); margin-bottom: 0.4rem; }
        .product-desc { font-size: 13px; color: #666; padding: 0 1.5rem 0 calc(8px + 0.75rem); line-height: 1.5; margin-bottom: 0.75rem; }

        .vol-selector { padding: 0 1.5rem 0 calc(8px + 0.75rem); margin-bottom: 0.75rem; }
        .vol-label { font-size: 11px; color: #aaa; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 0.5rem; }
        .vol-options { display: flex; flex-direction: column; gap: 6px; }
        .vol-btn { background: #F8F8F4; border: 1px solid #E8E8E0; border-radius: 8px; padding: 8px 12px; font-family: 'DM Sans', sans-serif; font-size: 13px; cursor: pointer; text-align: left; color: #555; transition: all 0.15s; display: flex; justify-content: space-between; align-items: center; }
        .vol-btn:hover { border-color: #ccc; background: #F0F0EA; }
        .vol-btn.vol-active { border-color: #4A6FA5; background: #EEF3F9; color: #1A1A18; font-weight: 500; }
        .vol-supplement { font-size: 11px; color: #8B4513; font-weight: 500; }
        .vol-btn.vol-active .vol-supplement { color: #4A6FA5; }

        .product-price-row { display: flex; align-items: baseline; gap: 6px; padding: 0.75rem 1.5rem 0 calc(8px + 0.75rem); }
        .product-price { font-family: 'Cormorant Garamond', serif; font-size: 2.2rem; font-weight: 400; color: #1A1A18; line-height: 1; }
        .product-currency { font-size: 1rem; color: #888; }
        .product-unit { font-size: 12px; color: #aaa; }

        .product-body { padding: 1rem 1.5rem 1.25rem; }
        .product-includes { list-style: none; margin-bottom: 1rem; }
        .product-includes li { font-size: 13px; color: #555; padding: 4px 0; display: flex; align-items: flex-start; gap: 8px; line-height: 1.4; }
        .check-icon { color: #6B9A4A; flex-shrink: 0; margin-top: 1px; font-size: 13px; }
        .product-target { font-size: 12px; color: #aaa; font-style: italic; border-top: 1px solid #F0F0E8; padding-top: 0.75rem; margin-bottom: 1rem; }

        .btn-buy { width: 100%; padding: 11px; border-radius: 8px; font-family: 'DM Sans', sans-serif; font-size: 14px; font-weight: 500; cursor: pointer; transition: all 0.2s; border: 1.5px solid #1A1A18; background: #fff; color: #1A1A18; }
        .btn-buy:hover { background: #1A1A18; color: #fff; }
        .btn-buy.popular-btn { background: #4A6FA5; color: #fff; border-color: #4A6FA5; }
        .btn-buy.popular-btn:hover { background: #3A5F95; }

        .subs-section { margin-top: 3.5rem; }
        .subs-header { display: flex; align-items: flex-end; justify-content: space-between; margin-bottom: 1.5rem; flex-wrap: wrap; gap: 1rem; }
        .subs-title { font-family: 'Cormorant Garamond', serif; font-size: 1.8rem; font-weight: 400; color: #1A1A18; }
        .subs-subtitle { font-size: 13px; color: #888; margin-top: 4px; }

        .cycle-switch { display: inline-flex; background: #EFEFEA; border-radius: 8px; padding: 3px; gap: 2px; }
        .cycle-btn { background: none; border: none; padding: 7px 16px; border-radius: 6px; font-family: 'DM Sans', sans-serif; font-size: 13px; cursor: pointer; color: #888; transition: all 0.2s; position: relative; }
        .cycle-btn.active { background: #fff; color: #1A1A18; font-weight: 500; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
        .cycle-badge { position: absolute; top: -7px; right: -4px; background: #4A6FA5; color: #fff; font-size: 9px; padding: 1px 4px; border-radius: 3px; font-weight: 600; }

        .subs-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 1.25rem; margin-bottom: 2rem; }

        .sub-card { background: #fff; border: 1px solid #E8E8E0; border-radius: 14px; padding: 1.5rem; position: relative; transition: box-shadow 0.2s, transform 0.2s; }
        .sub-card:hover { box-shadow: 0 8px 32px rgba(0,0,0,0.08); transform: translateY(-2px); }
        .sub-card.popular-sub { border-color: #4A6FA5; border-width: 1.5px; }
        .sub-card.recommended-sub { border-color: #8B4513; border-width: 1.5px; }
        .sub-badge { position: absolute; top: -12px; left: 50%; transform: translateX(-50%); font-size: 11px; padding: 3px 14px; border-radius: 20px; font-weight: 500; white-space: nowrap; }
        .sub-badge.pop { background: #4A6FA5; color: #fff; }
        .sub-badge.rec { background: #8B4513; color: #fff; }

        .sub-name { font-family: 'Cormorant Garamond', serif; font-size: 1.5rem; font-weight: 500; margin-bottom: 0.25rem; }
        .sub-content { font-size: 12px; color: #888; margin-bottom: 0.5rem; line-height: 1.5; }
        .sub-desc { font-size: 13px; color: #666; margin-bottom: 1rem; line-height: 1.5; }
        .sub-price-row { display: flex; align-items: baseline; gap: 4px; margin-bottom: 0.25rem; }
        .sub-price { font-family: 'Cormorant Garamond', serif; font-size: 2.4rem; font-weight: 400; color: #1A1A18; line-height: 1; }
        .sub-currency { font-size: 1rem; color: #888; }
        .sub-period { font-size: 13px; color: #aaa; }
        .sub-savings { font-size: 12px; color: #6B9A4A; font-weight: 500; margin-bottom: 1rem; }
        .sub-features { list-style: none; margin-bottom: 1.25rem; border-top: 1px solid #F0F0E8; padding-top: 1rem; }
        .sub-features li { font-size: 13px; color: #555; padding: 3px 0; display: flex; align-items: flex-start; gap: 8px; line-height: 1.4; }

        .btn-sub { width: 100%; padding: 11px; border-radius: 8px; font-family: 'DM Sans', sans-serif; font-size: 14px; font-weight: 500; cursor: pointer; transition: all 0.2s; border: 1.5px solid; }
        .btn-sub.default { border-color: #1A1A18; background: #fff; color: #1A1A18; }
        .btn-sub.default:hover { background: #1A1A18; color: #fff; }
        .btn-sub.pop-sub { background: #4A6FA5; color: #fff; border-color: #4A6FA5; }
        .btn-sub.pop-sub:hover { background: #3A5F95; }
        .btn-sub.rec-sub { background: #8B4513; color: #fff; border-color: #8B4513; }
        .btn-sub.rec-sub:hover { background: #7A3A0F; }

        .advantages-box { background: #1A1A18; color: #F5F5F0; border-radius: 14px; padding: 2rem; display: grid; grid-template-columns: 1fr 1fr; gap: 1.5rem; align-items: center; }
        .adv-title { font-family: 'Cormorant Garamond', serif; font-size: 1.5rem; font-weight: 300; margin-bottom: 0.5rem; color: #F5F5F0; }
        .adv-desc { font-size: 13px; color: #999; line-height: 1.6; }
        .adv-list { list-style: none; }
        .adv-list li { font-size: 13px; color: #CCC; padding: 6px 0; display: flex; align-items: center; gap: 10px; border-bottom: 1px solid rgba(255,255,255,0.06); }
        .adv-list li:last-child { border-bottom: none; }
        .adv-check { width: 18px; height: 18px; border-radius: 50%; background: rgba(107,154,74,0.2); display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-size: 11px; color: #8BC34A; }

        .vat-note { text-align: center; font-size: 12px; color: #aaa; margin-top: 1.5rem; }

        @media (max-width: 640px) {
          .advantages-box { grid-template-columns: 1fr; }
          .free-tier { flex-direction: column; align-items: flex-start; }
        }
      `}</style>

      <div className="pricing-wrap">
        <div className="pricing-hero">
          <h1>{L.title}</h1>
          <p>{L.subtitle}</p>
          <div className="tab-switcher">
            <button
              className={`tab-btn ${tab === "perReport" ? "active" : ""}`}
              onClick={() => setTab("perReport")}
            >
              {L.toggle.perReport}
            </button>
            <button
              className={`tab-btn ${tab === "subscriptions" ? "active" : ""}`}
              onClick={() => setTab("subscriptions")}
            >
              {L.toggle.subscriptions}
            </button>
          </div>
        </div>

        {tab === "perReport" && (
          <>
            <div className="free-tier">
              <div className="free-left">
                <div className="free-dot" />
                <div>
                  <div className="free-name">{L.freeTitle}</div>
                  <div className="free-desc">{L.freeDesc}</div>
                  <div className="free-limit">{L.freeLimit}</div>
                </div>
              </div>
              <button className="btn-free">{L.btnFree}</button>
            </div>

            <div className="products-grid">
              {PRODUCTS.map((p) => (
                <ProductCard key={p.id} product={p} L={L} />
              ))}
            </div>
          </>
        )}

        {tab === "subscriptions" && (
          <div className="subs-section">
            <div className="subs-header">
              <div>
                <div className="subs-title">{L.subsTitle}</div>
                <div className="subs-subtitle">{L.subsDesc}</div>
              </div>
              <div className="cycle-switch">
                <button
                  className={`cycle-btn ${billingCycle === "monthly" ? "active" : ""}`}
                  onClick={() => setBillingCycle("monthly")}
                >
                  {L.cycleMonthly}
                </button>
                <button
                  className={`cycle-btn ${billingCycle === "yearly" ? "active" : ""}`}
                  onClick={() => setBillingCycle("yearly")}
                >
                  {L.cycleYearly}
                  <span className="cycle-badge">{L.cycleBadge}</span>
                </button>
              </div>
            </div>

            <div className="subs-grid">
              {SUBSCRIPTIONS.map((s) => (
                <SubscriptionCard
                  key={s.id}
                  sub={s}
                  billingCycle={billingCycle}
                  L={L}
                />
              ))}
            </div>

            <div className="advantages-box">
              <div>
                <div className="adv-title">{L.advantages}</div>
                <div className="adv-desc">{L.advantagesDesc}</div>
              </div>
              <ul className="adv-list">
                {L.advantagesList.map((a, i) => (
                  <li key={i}>
                    <span className="adv-check">✓</span>
                    {a}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}

        <div className="vat-note">{L.vatNote}</div>
      </div>
    </div>
  );
}
